import { lazy } from 'react';
import { Route } from 'react-router';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { TransportRedirect } from 'src/pages/company-transactions/transport/tab-bar';
import { useCompanyTransactionsAccess } from 'src/pages/company-transactions/use-company-transactions-access';

const TransportRoutes = lazy(
  () => import('src/pages/company-transactions/transport')
);
const LngPage = lazy(() => import('src/pages/company-transactions/lng'));
const StoragePage = lazy(
  () => import('src/pages/company-transactions/storage')
);

export const CompanyTransactions = () => {
  const access = useCompanyTransactionsAccess();

  if (!access.loaded) return <PageSpinner />;

  if (!access.canAccess) return <ThrowNotFound />;

  return (
    <RootRoutes>
      <Route path="/company-transactions" element={<TransportRedirect />} />
      <Route
        path="/company-transactions/transport"
        element={<TransportRedirect />}
      />
      <Route
        path="/company-transactions/transport/*"
        element={<TransportRoutes />}
      />
      <Route path="/company-transactions/lng" element={<LngPage />} />
      <Route path="/company-transactions/storage" element={<StoragePage />} />
      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
